import 'core-js/es/array/find';
import 'core-js/es/array/find-index';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/string/starts-with';
import 'regenerator-runtime/runtime';
import * as React from 'react';
import { render } from 'react-dom';
import Weborder from './weborder/index';
import { flipdiv } from './weborder/Utilities';

require.include('file-loader?name=[name].[ext]!./weborder/pwa.html');

//import bowser = require('bowser');
require.include(
  'file-loader?name=[name].[ext]!./browserMessage/browserMessage.scss'
);
//import { createBrowserMessage } from './browserMessage/browserMessage';

//Load weborder stylesheet if weborder
if (process.env.REACT_APP_PLATFORM !== 'portal') {
  require('./weborder/index.scss');
}

//#region cleanup deprecated
function cleanupDeprecated() {
  const deprecatedStorageKeyTester = [
    // disable-local-storage-flipdish-delivery-options : whats the point of storing it when we always request it
    /flipdish-delivery-options/,
    // disable-local-storage-flipdish-restaurant-details : whats the point of storing it when we always request it
    /flipdish-restaurant-details/,
    // disable-local-storage-overflow : json responses r cashed by browser by default
    /\.json$/
  ];

  for (const key of Object.keys(localStorage)) {
    if (deprecatedStorageKeyTester.some(tester => tester.test(key))) {
      localStorage.removeItem(key);
    }
  }
}

//#endregion
cleanupDeprecated();

if (flipdiv) {
  flipdiv.classList.add('notranslate');
  render(<Weborder />, flipdiv);
}

(window as any).renderFlipdiv = () => {
  if (flipdiv) {
    render(<Weborder />, flipdiv);
  }
};
